import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import classNames from 'classnames';

import CardWithPopup from './CardWithPopup';
import { hasMore } from './utils';

import classes from './ClickableCardWithPopup.scss';

@withRouter
export default class ClickableCardWithPopup extends PureComponent {
  static propTypes = {
    history     : PropTypes.object.isRequired,
    moreLink    : PropTypes.string,
    moreText    : PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    moreElem    : PropTypes.element,
    articleClass: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  }

  onCardClick = (evt) => {
    if (!evt.currentTarget.contains(evt.target)) {
      // событие пришло из попапа, игнорируем
      return;
    }

    const { history, moreLink } = this.props;

    if (!evt.defaultPrevented && hasMore(this.props)) {
      history.push(moreLink);
    }
  }

  hasMore() {
    const { moreLink, moreText, moreElem, articleClass } = this.props;

    return Boolean((moreText || moreElem || articleClass) && moreLink);
  }

  render() {
    const cardHasMore = hasMore(this.props);
    const onCardClick = cardHasMore ? this.onCardClick : null;

    return (
      // Достаём WrappedComponent, чтобы не добавлять в дерево лишний withRouter
      <CardWithPopup.WrappedComponent
        {...this.props}
        className  = {classNames(this.props.className, { [classes.clickableCardWithPopup]: cardHasMore })}
        onClick    = {onCardClick}
        onTouchTap = {onCardClick} // для телефонов, почему-то иначе не работает...
      />
    );
  }
}
